// @flow
import * as React from 'react';
import { Link } from 'react-router';
import { Row, Col, Button, Image } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import editcampaign from '../../images/edit-campaign.png';
import fuzzyFilterFactory from 'react-fuzzy-filter';
import PaginatedList from '../../components/PaginatedList';
import SidebarFilterBox from '../../components/SidebarFilterBox';
import type { InsightSet } from '../../types';

type Params = {
  insightSetId: ?number
};

type Props = {
  params: Params,
  insightSets: InsightSet[],
  getInsightSets: () => void
};

type State = {
  showArchived: boolean,
  filterValue: string,
  currentItemName?: string
};

export default class InsightSetSidebar extends React.Component<Props, State> {
  fuzzyFilterFactory: any;
  updateFilterValue: any;
  screenReaderContent: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      showArchived: false,
      filterValue: ''
    };
    this.fuzzyFilterFactory = fuzzyFilterFactory();
    this.updateFilterValue = this.updateFilterValue.bind(this);
  }

  componentDidMount() {
    this.props.getInsightSets();
  }

  updateFilterValue(filterValue: ?string) {
    this.setState({ filterValue: filterValue || '' });
  }

  moveFocusToHeading = (item: InsightSet) => {
    this.setState({ currentItemName: item.name }, () =>
      this.screenReaderContent.focus()
    );
  };

  render() {
    const insightSetId = this.props.params.insightSetId || 'new';

    const LineItem = props => {
      const insightSet = props.item;
      return (
        <Row
          key={insightSet.id}
          className={`sidebar-list-item ${insightSet.isArchived && 'archived'}`}
          onClick={e => this.moveFocusToHeading(insightSet)}
        >
          <Link to={`/insight-sets/${insightSet.id}`}>
            <Col
              sm={10}
              className={`overflow-ellipsis map-link ${
                insightSetId === insightSet.id.toString() ? 'active' : ''
              }`}
            >
              <p title={insightSet.name}>
                <strong>{insightSet.name}</strong>
              </p>
              <small title={`Created by ${insightSet.createdBy}`}>
                Created by {insightSet.createdBy}
              </small>
            </Col>
          </Link>
          <Link to={`/insight-sets/${insightSet.id}`}>
            <Col sm={2} className="edit-btn text-center campaign-edit-link">
              <Image src={editcampaign} responsive alt="Edit Campaign" />
              <span className="campaign-edit-link-text">Edit</span>
            </Col>
          </Link>
        </Row>
      );
    };

    return (
      <div className="generic-sidebar">
        <Row>
          <Col sm={12} md={6}>
            <h3
              className="screen-reader-only"
              tabIndex="-1"
              ref={i => (this.screenReaderContent = i)}
            >
              Editing insight set {this.state.currentItemName}
            </h3>
            <h1>Insight Sets</h1>
          </Col>

          <Col sm={12} md={6}>
            <div className="sidebar-new-btn">
              <LinkContainer to="/insight-sets/new">
                <Button bsStyle="primary" className="new-btn">
                  Create New
                </Button>
              </LinkContainer>
            </div>
          </Col>

          <Col sm={12}>
            <SidebarFilterBox
              onChange={this.updateFilterValue}
              fuzzyFilterFactory={this.fuzzyFilterFactory}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <PaginatedList
              filterValue={this.state.filterValue}
              component={LineItem}
              items={this.props.insightSets}
              showArchived={this.state.showArchived}
              fuzzyFilterFactory={this.fuzzyFilterFactory}
              pluralName="insight sets"
              keys={['name']}
              threshold={0.5}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={12} lg={12} className="show-archived-wrapper">
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                name="archiveCheckbox"
                id="archiveCheckbox"
                className="archive-checkbox"
                checked={this.state.showArchived}
                onChange={() =>
                  this.setState({ showArchived: !this.state.showArchived })
                }
              />
              <label htmlFor="archiveCheckbox" className="checkbox-label">
                Show Archived
              </label>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/insightset/InsightSetSidebar.js